<template>
    <div class="service">
        <input type="checkbox" name="services[]" :value="serviceOption"
            :id="`order-service-${serviceOption.id}`" @change="toggleService($event, serviceOption)" :checked="isChecked">
        <div class="text">
            <label :for="`order-service-${serviceOption.id}`">{{ serviceOption.name }}</label>
            <p v-if="serviceOption.text" v-html="serviceOption.text"></p>
            <p class="addition">{{ $t('OPTIONAL') }}</p>
        </div>
    </div>
</template>
<script>
import { computed } from "@vue/reactivity";
import useOrderService from "./useOrderService"

export default {
    props: {
        serviceOption: {
            type: Object,
        },
    },
    setup(props) {
        const {
            isCheckedService,
            toggleService,
        } = useOrderService()
        const isChecked = computed(() => isCheckedService(props.serviceOption))

        return {
            isChecked,
            toggleService,
        }
    }
}
</script>
